export default /* css */ `
syntax-highlighting {
  margin: calc(var(--ui-sys-unit) * 32) 0;
}

ui-divider {
  margin: calc(var(--ui-sys-unit) * 32) 0;
}

.smiley {
  font-size: 24px;
}

code {
  padding: 2px 4px;
  border-radius: 4px;
  background-color: hsl(var(--ui-sys-color-surface-bright));
  color: hsl(var(--ui-sys-color-primary));
}
`
